var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15H13.5V16.5H22.5V15Z",
    fill: "#67C2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18H13.5V19.5H22.5V18Z",
    fill: "#67C2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21H13.5V22.5H22.5V21Z",
    fill: "#67C2E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5C10.2775 13.5 10.06 13.566 9.87499 13.6896C9.68998 13.8132 9.54579 13.9889 9.46064 14.1945C9.37549 14.4001 9.35321 14.6263 9.39662 14.8445C9.44003 15.0627 9.54717 15.2632 9.70451 15.4205C9.86184 15.5778 10.0623 15.685 10.2805 15.7284C10.4988 15.7718 10.725 15.7495 10.9305 15.6644C11.1361 15.5792 11.3118 15.435 11.4354 15.25C11.559 15.065 11.625 14.8475 11.625 14.625C11.625 14.3266 11.5065 14.0405 11.2955 13.8295C11.0845 13.6185 10.7984 13.5 10.5 13.5Z",
    fill: "#265EA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.25H9.75V12H11.25V5.25Z",
    fill: "#265EA7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3C12.4885 3.00221 14.3948 3.79309 15.8009 5.19914C17.2069 6.60518 17.9978 8.51156 18 10.5H19.5C19.5 8.71997 18.9722 6.97991 17.9832 5.49987C16.9943 4.01983 15.5887 2.86628 13.9442 2.18509C12.2996 1.5039 10.49 1.32567 8.74419 1.67294C6.99836 2.0202 5.39472 2.87737 4.13604 4.13604C2.87737 5.39472 2.0202 6.99836 1.67294 8.74419C1.32567 10.49 1.5039 12.2996 2.18509 13.9442C2.86628 15.5887 4.01983 16.9943 5.49987 17.9832C6.97991 18.9722 8.71997 19.5 10.5 19.5V18C8.51088 18 6.60323 17.2098 5.1967 15.8033C3.79018 14.3968 3 12.4891 3 10.5C3 8.51088 3.79018 6.60323 5.1967 5.1967C6.60323 3.79018 8.51088 3 10.5 3Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOther);
export default __webpack_public_path__ + "static/media/WarningOther.abc6718898486ef366fd66223fb00f93.svg";
export { ForwardRef as ReactComponent };